module.exports = __webpack_public_path__ + "static/media/YonderMountainStringBandCabinFevrTour2012posterdesigninspiration.bbc0e91a.webp";